import React, { useState, useEffect } from "react";
import moment from "moment";
import ConsultasCard from "../../../components/Consultas/ConsultasCard";
import HeaderLogado from "../../../components/common/Authenticated/Header/HeaderLogado";
import BottomMenu from "../../../components/common/Authenticated/Menu/Menu";
import api from "../../../services/api"; // sua instância axios
import LoadingComponent from "../../../components/common/LoadingComponent";

function Consultas() {
  const hoje = moment();

  const [selectedOption, setSelectedOption] = useState("Todas");
  const [consultas, setConsultas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConsultas = async () => {
      try {
        setLoading(true);
        const clienteId = JSON.parse(localStorage.getItem("usuario"))._id;
        const token = localStorage.getItem("token");

        const { data } = await api.get(`agendamento/${clienteId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!data.error) {
          const consultasFormatadas = data.agendamentos.map((agendamento) => ({
          imagem:
            agendamento.colaboradorId?.foto ||
            "https://www.gravatar.com/avatar/?d=mp&s=200",
          especialidade: agendamento.servicoId?.titulo || "Serviço não definido",
          profissional: agendamento.colaboradorId?.nome || "Profissional",
          data: agendamento.data, // 👈 passa cru
          status:
            agendamento.status === "C"
              ? "Cancelada"
              : hoje.isAfter(moment(agendamento.data)) &&
                agendamento.status === "A"
              ? "Realizada"
              : "Agendada",
        }));


          setConsultas(consultasFormatadas);
        } else {
          console.error(data.message);
        }
      } catch (err) {
        console.error("Erro ao buscar consultas:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConsultas();
  }, []);

  let consultasFiltradas = consultas;
  if (selectedOption !== "Todas") {
    consultasFiltradas = consultas.filter(
      (consulta) => consulta.status === selectedOption
    );
  }

  return (
    <>
      <HeaderLogado />
      <div className="bg-gray-100 min-h-svh">
          <div className="p-5 space-y-1 max-w-4xl mx-auto bg-gray-100">
          {/* Filtro */}
          <div className="flex space-x-3 border-gray-400 mb-4 w-full overflow-x-auto whitespace-nowrap hide-scrollbar">
            {["Todas", "Realizada", "Agendada", "Cancelada"].map((option) => (
              <button
                key={option}
                onClick={() => setSelectedOption(option)}
                className={`pb-2 font-bold ${
                  selectedOption === option
                    ? "border-b-4 border-[#003D42] text-white bg-[#003D42]"
                    : "border-[1.9px] border-solid border-[#003D42] text-[#003D42] hover:text-[white] bg-white"
                }`}
              >
                {option}
              </button>
            ))}
          </div>

          {/* Consultas */}
          {loading ? (
            <LoadingComponent/>
          ) : consultasFiltradas.length > 0 ? (
            <div className="space-y-4 pb-20">
              {consultasFiltradas.map((consulta, idx) => (
                <ConsultasCard
                  key={idx}
                  imagem={consulta.imagem}
                  especialidade={consulta.especialidade}
                  profissional={consulta.profissional}
                  data={consulta.data}
                  status={consulta.status}
                />
              ))}
            </div>
          ) : (
            <div className="flex justify-center items-center h-48 text-gray-600">
              Não há nada para mostrar.
            </div>
          )}
        </div>
      </div>
      <BottomMenu />
    </>
  );
}

export default Consultas;
